import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import Sidebar from "./Sidebar";
import Header from "./header";
import DashboardFooter from "./dashboardfooter";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useAuth } from "../context/AuthContext";
import { useTranslation } from "../hooks/useTranslation";

function Layout({ children }) {
  const location = useLocation();
  const path = location.pathname;
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const authRoutes = [
    "/login",
    "/register",
    "/otpverification",
    "/tableconfirmationafterpayment/",
    "/forgotpassword",
    "/app-payment-redirect",
    "/app-redirect",
    "/payment-failed",
  ];
  const { token } = useAuth();
  const { t } = useTranslation();

  const simpleRoutes = [
    "/",
    "/about",
    "/terms",
    "/privacy",
    "/hotelbooking",
    "/hoteldetail",
    "/restaurantordering",
    "/login-instructor",
    "/tableconfirmation",
    "/restaurantdetail",
    "/tablecode",
    "/cart",
    "/orderconfirmation",
    "/trackorder",
    "/userprofile",
    "/checkout",
    "/user-bookings",
    "/hotel-menu",
    "/hotel-cart",
    "/usersupport",
    "/user-orders",
    "/nearby-hotels"
  ];

  const sidebarRoutes = [
    // Owner routes
    "/ownerdashboard",
    "/roomlisting",
    "/addnewroom",
    "/addnewhotel",
    "/userhoteldetail",
    "/restaurant",
    "/addnewrestaurant",
    "/slots",
    "/settingsusers",
    "/addrestaurantmenu",
    "/addhotelmenu",
    "/orders",
    "/hotel-orders",
    "/reservationforhotels",
    "/reservationforrestaurants",
    "/customersupport",
    "/reviewandfeedback",
    "/managehotels",
    "/managerestaurants",
    "/restaurantoffers",
    "/restaurantofferdetail",
    "/hoteloffers",
    "/hotelofferdetail",
    "/floor-plan",
    "/wallet",

    // Admin routes
    "/admindashboard",
    "/restaurantmanagement",
    "/commissions",
    "/language-management",
    "/referral-management",
    "/restaurantdetailpage",
    "/hotelmanagement",
    "/hoteldetailpage",
    "/usermanagement",
    "/adminsubadminroles",
    "/support",
    "/adminsettings",
    "/promotionslist",
    "/promotiondetail",
    "/sponsored",
  ];

  const guestRoutes = [
    "/hotel-menu",
  ];

  // if (
  //   guestRoutes.some((route) =>
  //     path.startsWith(route)
  //   )
  // ) {
  //   return (
  //     <>
  //       <Navbar t={t}></Navbar>
  //       <div>{children}</div>
  //       <Footer />
  //     </>
  //   );
  // }

  if (authRoutes.some((route) => path.startsWith(route))) {
    return <div>{children}</div>;
  }

  if (simpleRoutes.includes(path)) {
    return (
      <>
        <Navbar t={t}></Navbar>
        <div>{children}</div>
        <Footer />
      </>
    );
  }

  if (authRoutes.some((route) => path.startsWith(route))) {
    return <div>{children}</div>;
  }

  // ✅ Handle all /guest/* routes
  if (path.startsWith("/guest")) {
    return (
      <>
        <Navbar t={t} />
        <div className="bg-[#FAFAFA] min-h-screen">{children}</div>
        <Footer />
      </>
    );
  }

  if (sidebarRoutes.some((route) => path.startsWith(route))) {
    return (
      <div className="grid lg:grid-cols-[auto_1fr] grid-cols-1 md:h-screen h-full w-full">
        <Sidebar open={sidebarOpen} setOpen={setSidebarOpen} />
        <div className="w-full">
          <Header />
          <div className="lg:overflow-y-auto flex-1 main-overflow lg:p-[30px] md:p-[20px] p-[15px] bg-[#FAFAFA]">
            {children}
          </div>
          <DashboardFooter />
        </div>
      </div>
    );
  }
}

export default Layout;
